require('./bootstrap');

window.Vue = require('vue');

import vDialog from 'v-dialogs';
Vue.use(vDialog, {dialogMaxButton: false, dialogCloseButton: false, language: 'en', title: ''});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import Tabs from 'vue-tabs-component';
Vue.use(Tabs);
Vue.config.ignoredElements = [/ion-icon/];

Vue.component('push-sender', require('./components/PushSender.vue').default);
Vue.component('product-editor', require('./components/ProductEditor.vue').default);
Vue.component('order-items-editor', require('./components/OrderItemsEditor.vue').default);
Vue.component('training-videos-editor', require('./components/TrainingVideosEditor.vue').default);

$(document).on('click', 'a[role=tab]',function(e){
	e.preventDefault();
})

const app = new Vue({
	el: '#app',
});
